<template>
  <div class="wrapper" v-if="data.title">
    <Menu />
    <div class="header-area bg-transparent position-absolute w-100 border-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <a @click="$router.go(-1)" href="javascript:;">
              <span class="back-arrow mt-4"></span>
            </a>
          </div>
          <div class="col-6 text-right">
            <a
              href="javascript:;"
              @click="$openShare('https://www.anadoluefessk.org/foto-galeri/' + data.slug, data.title)"
            >
              <span class="menu-dot mt-4"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="slider-box position-relative">
              <img :src="data.featured_image.image_960" class="w-100 slider-image" />
              <h1 class="fs-32 fc-5 slider-title position-absolute z-9">{{data.title}}</h1>
              <div class="news-gra"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="col-12 p-0" style="margin-top: 20px; position: unset">
              <Gallery @onShareClicked="onShare" :isLimited="false" :data="images" />
            </div>
          </transition>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import Gallery from "@/components/Gallery";
import axios from "axios";
export default {
  name: "GalleryDetail",
  components: {
    Footer,
    Menu,
    Header,
    Gallery
  },
  data() {
    return {
      data: {
        slug: this.$route.params.slug
      }
    };
  },
  methods: {
    onShare() {
      this.$openShare(
        "https://www.anadoluefessk.org/foto-galeri/" + this.data.slug,
        this.data.title
      );
    }
  },
  created() {
    axios.get("foto-galeri/detay?slug=" + this.$route.params.slug).then(res => {
      this.data = res.data.data;
    });
  },
  computed: {
    images() {
      var imgs = [];

      this.data.content.map(item => {
        imgs.push({
          image: item.image.original,
          image_thumb: item.image.image_480
        });
      });

      return imgs;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/GalleryDetail.vue